<template>
  <div class="overflow-auto">
    <table class="table table-xs md:table-sm xl:table-md" v-if="appointments.length">
      <thead>
        <tr>
          <th>#</th>
          <th>{{ __("Subject") }}</th>
          <th>{{ __("Type") }}</th>
          <th>{{ __("Status") }}</th>
          <th>{{ __("Time") }}</th>
          <th>{{ __("Parent Type") }}</th>
          <th>{{ __("User") }}</th>
          <!-- <th>{{ __("Update date") }}</th> -->
          <th>{{ __("Action") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in appointments">
          <td>{{ (meta.per_page ?? 1) * ((meta.current_page ?? 1) - 1) + index + 1 }}</td>
          <td>{{ item.subject }}</td>
          <td>{{ __(item.type?.capitalize()) }}</td>
          <td>
            {{ __(item.status?.replace("_", " ")?.capitalize()) || "---" }}
          </td>
          <td>{{ item.date }}</td>
          <td>{{ __(item.parent_type?.capitalize()) }}</td>
          <td>{{ item.user }}</td>
          <!-- <td>{{ item.updated_at }}</td> -->
          <td>
            <div @click="
              pushTo('show', {
                name: 'user.appointment.show',
                params: { id: item.id },
              })
              " :class="{
                'btn-disabled':
                  !can('appointment.view.all') &&
                  !can('appointment.view.self', item.self),
              }" class="btn btn-outline btn-primary btn-sm ml-2">
              {{ __("Show") }}
            </div>
            <div @click="
              pushTo('edit', {
                name: 'user.appointment.edit',
                params: { id: item.id },
              })
              " :class="{
                'btn-disabled':
                  !can('appointment.edit.all') &&
                  !can('appointment.edit.self', item.self),
              }" class="btn btn-outline btn-info btn-sm ml-2">
              {{ __("Edit") }}
            </div>
            <label @click="setItem(item)" for="appointment-delete-modal" :class="{
              'btn-disabled':
                !can('appointment.delete.all') &&
                !can('appointment.delete.self', item.self),
            }" class="btn btn-outline btn-error btn-sm">
              {{ __("Delete") }}
            </label>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="col-span-12 flex flex-col items-center mt-9" v-else>
      <NotFound />
    </div>
  </div>
</template>
<script setup>
const {
  meta,
  router,
} = useDashboard();
const props = defineProps(["appointments", "modal"]);
const emit = defineEmits(['setItem']);
const pushTo = (type, route) => {
  if (props.modal) emit(type, type, route.params.id);
  else router.push(route);
};
const setItem = (item) => emit('setItem', item);
</script>
